const translations = {
  // Actions
  edit: "Edit",
  delete: "Delete",
  save: "Save",
  cancel: "Cancel",
  accept: "Accept",
  submit: "Submit",
  confirm: "Confirm",
  close: "Close",
  create: "Create",
  done: "Done",
  yes: "Yes",
  no: "No",
  ok: "OK",
  apply: "Apply",
  reset: "Reset",
  clear: "Clear",
  search: "Search",
  filter: "Filter",
  print: "Print Preview",
  download: "Download",
  upload: "Upload",
  back: "Back",
  next: "Next",
  previous: "Previous",
  add: "Add New",
  addItem: "Add Item",
  remove: "Remove",
  view: "View",
  viewAll: "View All",
  update: "Update",
  refresh: "Refresh",
  export: "Export",
  send: "Send",
  copy: "Copy",
  paste: "Paste",
  select: "Select",
  selectAll: "Select All",
  deselect: "Deselect",
  // Status
  active: "Active",
  inactive: "Inactive",
  pending: "Pending",
  completed: "Completed",
  cancelled: "Cancelled",
  approved: "Approved",
  rejected: "Rejected",
  draft: "Draft",
  open: "Open",
  closed: "Closed",
  paid: "Paid",
  unpaid: "Unpaid",
  partial: "Partial",
  overdue: "Overdue",
  // Feedback
  loading: "Loading…",
  saving: "Saving…",
  success: "Success",
  error: "Error",
  warning: "Warning",
  info: "Info",
  noRecords: "No records found.",
  noData: "No data available.",
  // Fields
  name: "Name",
  fullName: "Full Name",
  phone: "Phone",
  altPhone: "Alt. Phone",
  email: "Email",
  address: "Address",
  city: "City",
  state: "State",
  notes: "Notes",
  remarks: "Remarks",
  date: "Date",
  time: "Time",
  type: "Type",
  status: "Status",
  action: "Action",
  amount: "Amount",
  total: "Total",
  subtotal: "Subtotal",
  grandTotal: "Grand Total",
  gst: "GST",
  balance: "Balance",
  paidAmount: "Paid Amount",
  balanceDue: "Balance Due",
  outstanding: "Outstanding Balance",
  // Gold / Jewellery terms (kept in English per financial log normalization policy)
  fineGold: "Fine Gold",
  touchPurity: "Touch / Purity",
  wastage: "Wastage",
  goldAdvance: "Gold Advance",
  wastageReturn: "Wastage Return",
  rateCutTerms: "Rate Cut",
  passbook: "Passbook",
  settlement: "Settlement",
  goldRate: "Gold Rate (₹/g)",
  makingCharge: "Making Charge",
  stoneCharge: "Stone / Other Charges",
  grossWeight: "Gross Weight",
  netWeight: "Net Weight",
  purity: "Purity",
  barcode: "Barcode",
  huid: "HUID",
  weightGrams: "Weight (g)",
  weightMg: "Weight (mg)",
  // Currency
  rupees: "Rupees (₹)",
  paise: "Paise",
  // Misc
  deliveryDate: "Expected Delivery",
  comingIn: "Coming soon",
  unlockedNotice: "This section unlocks after the previous phase is verified.",
  liveMetalRates: "Live Metal Rates",
  required: "Required",
  optional: "Optional",
  na: "N/A",
  all: "All",
  none: "None",
  or: "or",
  and: "and",
  of: "of",
  by: "by",
  for: "for",
  in: "in",
  to: "to",
  from: "from",
  on: "on",
  at: "at",
  yes_confirm: "Yes, confirm",
  are_you_sure: "Are you sure?",
  cannot_undo: "This action cannot be undone.",
  // Date/Time
  today: "Today",
  yesterday: "Yesterday",
  tomorrow: "Tomorrow",
  thisWeek: "This Week",
  thisMonth: "This Month",
  // Table
  noResultsFound: "No results found.",
  tryDifferentSearch: "Try a different search term.",
  // Validation
  fieldRequired: "This field is required.",
  invalidEmail: "Invalid email address.",
  invalidPhone: "Invalid phone number.",
  minLength: "Too short.",
  maxLength: "Too long.",
  // File
  fileUpload: "Upload File",
  fileSize: "Max file size",
  fileType: "Supported types",
};

export default translations;
